export type EventMap = Record<string, unknown>;

type Listener<T> = (detail: T) => void;

export class Dispatcher<TEvents extends EventMap = EventMap> {
  private listeners = new Map<keyof TEvents, Listener<unknown>>();

  on<K extends keyof TEvents>(type: K, listener: Listener<TEvents[K]>) {
    this.listeners.set(type, listener as Listener<unknown>);
  }

  off<K extends keyof TEvents>(type: K) {
    this.listeners.delete(type);
  }

  emit<K extends keyof TEvents>(type: K, detail: TEvents[K]) {
    this.listeners.get(type)?.(detail);
  }

  destroy() {
    this.listeners.clear();
  }
}
